import { useState, useEffect } from 'react';
import { getProjectConfig } from '../modules/executions';

const useExecutionScope = (projectId) => {
  const [scopeStatus, setScopeStatus] = useState({
    isLoading: true,
    isScopeDefined: false,
    isPlatformsDefined: false,
  });

  useEffect(() => {
    if (!projectId) return;

    const fetchScope = async () => {
      try {
        const config = await getProjectConfig(projectId);

        const hasPlatforms = config?.platforms?.length > 0;
        const hasOtherScope =
          config?.languages?.length > 0 ||
          config?.geographies?.length > 0 ||
          config?.cloud_device?.length > 0 ||
          config?.browsers?.length > 0;

        setScopeStatus({
          isLoading: false,
          isScopeDefined: hasPlatforms || hasOtherScope,
          isPlatformsDefined: hasPlatforms,
        });
      } catch (err) {
        console.error('Failed to fetch execution scope:', err);
        setScopeStatus((prev) => ({ ...prev, isLoading: false }));
      }
    };

    fetchScope();
  }, [projectId]);

  return scopeStatus;
};

export default useExecutionScope;
